export default{
    message:{
        text:'hello world'
    }
}